import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { MARK_AS_LOGIN } from "../../redux/actions/types";

const CareRegistration5 = ({ auth, login }) => {
    const navigate = useNavigate();
    const doLogin = () => {
        login();
        navigate("/");
    };
    return (
        <>
            <Header />
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Care Giver Registration</h2>
                            <p>
                                You can register and connect with a specialist
                                caregiver or home-helper by following our 5-step
                                easy process.
                            </p>
                        </div>
                        <div className="tab_nav" role="tablist">
                            <span className="borderTop"></span>
                            <ul
                                className="navs nav-tabs"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item">
                                    <span className="count">1</span>
                                    <h6>Service Selection</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">2</span>
                                    <h6>Service Setup</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">3</span>
                                    <h6>Build Trust</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">4</span>
                                    <h6>Finalization</h6>
                                </li>
                                <li className="nav-item active">
                                    <span className="count">5</span>
                                    <h6>Payment</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div id="step5">
                        <section className="connect_stripe">
                            <div className="head_wrapper text-center">
                                <h5>
                                    Get Your Account ready to recieve Payments
                                </h5>
                                <p>
                                    Get Funds directly deposited into your bank
                                    account, with no additional fees.
                                    Myhomehelper uses stripe, one of the most
                                    popular payment platforms, to transfer your
                                    earnings to your bank account. Set up your
                                    stripe account seamlessly with one click and
                                    at no additional cost to you.
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-secondary mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration-4?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                <a
                                    onClick={doLogin}
                                    id="join-now-btn"
                                    className="btn btn-secondary"
                                    target="_blank"
                                    href={auth.user.on_boarding}
                                    style={{ fontWeight: 700 }}
                                >
                                    Connect to Stripe
                                </a>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    login: () => dispatch({ type: MARK_AS_LOGIN }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CareRegistration5);
